import { AxiosResponse } from "axios";
import axiosInstance from "./base";
import { IPdfRepport } from "../shared/types/pdfRepports.type";

export class DataSuccessService {


    static getRepports(userId?: string, options?: string): Promise<AxiosResponse<IPdfRepport[]>> {
        return axiosInstance.get(`/pdf_reports?user=${userId}`.concat(options ? `&${options}` : ""))
    }

}